import { createPinia } from "pinia";
const Pinia = createPinia()
export default Pinia

